import ActivityCodeFormConfig from "./form";
import { ActivityCodeApi, ActivityCodeDataType } from "@/api/ActivityCodeApi";
import { ActivityCodeFormData } from "@/formTypes/ActivityCodeFormDataType";
import GenericForm from "../GenericForm";

type ActivityCodeFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string;
  ownerTenantId?: string;
}

const ActivityCodeForm = (props: ActivityCodeFormProps) => {
  const { ownerTenantId } = props;

  const createFn = (data: ActivityCodeDataType) =>
    ActivityCodeApi.create(ownerTenantId ? { ...data, owner: ownerTenantId } : data);

  return (
    <GenericForm<ActivityCodeFormData, ActivityCodeDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={ActivityCodeFormConfig}
      getById={(...arg) => ActivityCodeApi.get(...arg)}
      createFn={createFn}
      updateFn={(...arg) => ActivityCodeApi.update(...arg)}
      successMessage="La Actividad economica ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información de la actividad economica"
    />
  )
}

export default ActivityCodeForm;
